import { mapState } from 'vuex';
import { routerJump } from '@/assets/js/utils';
export default {
  data() {
    return {
      type: 0,
      acceptVal: 1,
      buttonText: this.$t('start.join'),
      partyCode: ''
    };
  },
  created() {
    const {
      collaborateLogId,
      optionType,
      type,
      partyCode
    } = this.$route.query;
    this.acceptVal = optionType;
    this.type = Number(type);
    this.partyCode = partyCode;
    this.controlInvite(optionType, collaborateLogId);
  },
  computed: {
    ...mapState({
      State: state => state,
      homeLogo: state => state.homeLogo
    }),
    title() {
      if (this.acceptVal == 1) {
        this.type ? this.buttonText = this.$t('start.join') : this.buttonText = this.$t('partylineGuest.backHome');
        return this.$t('personalInfo.acceptedRequest');
      } else if (this.acceptVal == 2) {
        this.buttonText = this.$t('partylineGuest.backHome');
        return this.$t('personalInfo.declineRequest');
      } else {
        this.buttonText = this.$t('partylineGuest.backHome');
        return this.$t('personalInfo.RequestExpired');
      }
    },
    content() {
      if (this.acceptVal == 1 && (this.type == 0 || !this.type)) {
        return this.$t('personalInfo.acceptedRequestText');
      } else if (this.acceptVal == 2 && (this.type == 0 || !this.type)) {
        return this.$t('personalInfo.declineRequestText');
      } else {
        return this.$t('personalInfo.RequestExpiredText');
      }
    },
    contents() {
      if (this.acceptVal == 1 && this.type == 1) {
        return this.$t('personalInfo.acceptedCoHostRequestText');
      } else if (this.acceptVal == 2 && this.type == 1) {
        return this.$t('personalInfo.declineCoHostRequestText');
      } else {
        return this.$t('personalInfo.RequestCoHostExpiredText');
      }
    }
  },
  methods: {
    jump() {
      const hasLogin = this.State.hasLogin;
      if (hasLogin) {
        if (!this.partyCode) return;
        routerJump('manage');
      } else {
        routerJump('joinOrStart');
      }
    },
    // 协作&&co-host
    controlInvite(optionType, collaborateLogId) {
      if (!optionType || !collaborateLogId) return;
      const params = {
        collaborateLogId: collaborateLogId,
        optionType
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '82203101') {
          this.acceptVal = 3; // 3代表过期
        }
      });
    }
  }
};